import React from 'react'

import styles from './styles/progress-bar-counter.scss'

class ProgressCounter extends React.Component {
  render() {
    return (
      <div className={styles.counter}>
        {this.props.current} / {this.props.max}
      </div>
    )
  }
}

export default ProgressCounter



// WEBPACK FOOTER //
// ./src/components/ProgressCounter.js